<template lang="html">
  <div class="businessUnit">
    <div class="content-i">
        <div class="content-box">
          <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
              <div class="element-wrapper">
                <h6 class="element-header">{{ t('buAddNewUnitHeader', 'buAddNewUnitHeader') }}</h6>
                <div class="element-box" v-if="getBusinessUnitInfo">
                  <form id="formBusinessUnitUpdate" v-on:submit.prevent="addBusinessUnit">
                    <div class="row">
                      <div class="col-sm-12">
                        <router-link :to="{ name: 'client_configuration' }">
                        <button class="btn btn-secondary"> < {{ t('backToClientConfBtnText', 'backToClientConfBtnText') }}</button>
                      </router-link>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 col-md-6 col-lg-4">
                        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                          <b-input-group>
                            <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                              <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('buFullNameLabelText', 'buFullNameLabelText') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input id="business_name" v-model="unitData.name" required></b-form-input>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                          <b-input-group>
                            <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                              <b-input-group-text class="col-12 pretext"><span class="pretext-span">{{ t('buShortNameLabelText', 'buShortNameLabelText') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input id="business_short_name" required v-model="unitData.short_name" required></b-form-input>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                          <b-input-group>
                            <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                              <b-input-group-text class="col-12 pretext"><span class="pretext-span">{{ t('buWebsiteUrlLabelText', 'buWebsiteUrlLabelText') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input id="business_website_url" v-model="unitData.website_url"></b-form-input>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                          <b-input-group>
                            <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                              <b-input-group-text class="col-12 pretext"><span class="pretext-span">{{ t('buPrincipalLabelText', 'buPrincipalLabelText') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input id="business_principal" v-model="unitData.principle"></b-form-input>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                          <b-input-group>
                            <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                              <b-input-group-text class="col-12 pretext"><span class="pretext-span">{{ t('buLogoLabelText', 'buLogoLabelText') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-select v-model="selectedLogo" @change="changeSelectedLogo($event)">
                              <option v-for="logo in getAvailableBusinessUnitLogos" :value="logo.basename">{{ logo.basename }}</option>
                            </b-form-select>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                          <b-input-group>
                            <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                              <b-input-group-text class="col-12 pretext"><span class="pretext-span">{{ t('buBackgroundLabelText', 'buBackgroundLabelText') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-select v-model="selectedBackground" @change="changeSelectedBackground($event)">
                              <option v-for="background in getAvailableBusinessUnitBackgrounds" :value="background.basename">{{ background.basename }}</option>
                            </b-form-select>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                          <b-input-group>
                            <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                              <b-input-group-text class="col-12 pretext"><span class="pretext-span">{{ t('buLoginLogoLabelText', 'buLoginLogoLabelText') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-select v-model="selectedLoginLogo" @change="changeSelectedLoginLogo($event)">
                              <option v-for="logo in getAvailableBusinessUnitLogos" :value="logo.basename">{{ logo.basename }}</option>
                            </b-form-select>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group class="mt-3 col-lg-12 col-sm-12 padding-fix">
                          <b-input-group>
                            <b-input-group-prepend class="col-lg-4 col-sm-6 p-0">
                              <b-input-group-text class="col-12 pretext"><span class="pretext-span">{{ t('buLoginBackgroundLabelText', 'buLoginBackgroundLabelText') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-select v-model="selectedLoginBackground" @change="changeSelectedLoginBackground($event)">
                              <option v-for="background in getAvailableBusinessUnitBackgrounds" :value="background.basename">{{ background.basename }}</option>
                            </b-form-select>
                          </b-input-group>
                        </b-form-group>
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-8 logos-div text-center">
                        <div class="logo-box col-3">
                          <b class="col-sm-12">Navbar logo</b>
                          <div class="logo-preview mt-2">
                            <img v-if="this.selectedLogo" :src="getImgUrl('businessUnitLogos') + this.selectedLogo" :alt="this.selectedLogo" />
                            <span v-else class="no-logo-img">
                              <span class="no-logo-text">{{ t('noLogoText', 'noLogoText') }}</span>
                            </span>
                          </div>
                        </div>
                        <div class="logo-box col-3">
                          <b class="col-sm-12">Navbar background</b>
                          <div class="logo-preview mt-2">
                            <img v-if="this.selectedBackground" :src="getImgUrl('businessUnitBackgrounds') + this.selectedBackground" :alt="this.selectedBackground" />
                            <span v-else class="no-logo-img">
                              <span class="no-logo-text">{{ t('noLogoText', 'noLogoText') }}</span>
                            </span>
                          </div>
                        </div>
                        <div class="logo-box col-3">
                          <b class="col-sm-12">Login logo</b>
                          <div class="logo-preview mt-2">
                            <img v-if="this.selectedLoginLogo" :src="getImgUrl('businessUnitLogos') + this.selectedLoginLogo" :alt="this.selectedLoginLogo" />
                            <span v-else class="no-logo-img">
                              <span class="no-logo-text">{{ t('noLogoText', 'noLogoText') }}</span>
                            </span>
                          </div>
                        </div>
                        <div class="logo-box col-3">
                          <b class="col-sm-12">Login background</b>
                          <div class="logo-preview mt-2">
                            <img v-if="this.selectedLoginBackground" :src="getImgUrl('businessUnitBackgrounds') + this.selectedLoginBackground" :alt="this.selectedLoginBackground" />
                            <span v-else class="no-logo-img">
                              <span class="no-logo-text">{{ t('noLogoText', 'noLogoText') }}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <ResponseInfo v-if="getResponseInfo.responseName == 'businessUnitAdd'"></ResponseInfo>
                        <div class="form-buttons-w">
                          <button class="btn btn-primary" type="submit">{{ t('buCreateUnitBtnText', 'buCreateUnitBtnText') }}</button>
                          <router-link :to="{ name: 'client_configuration' }" class="ml-2">
                            <button class="btn btn-secondary">{{ t('cancelBtnText', 'cancelBtnText') }}</button>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResponseInfo from '@/components/ResponseInfo'
import { clientShortName } from '@/helpers/clientShortName.js'
import { awsUrl } from '@/helpers/awsUrl.js'
import { mapGetters } from 'vuex'

export default {
    name: 'BusinessUnit',
    data () {
      return {
        unitData: {
          name: '',
          short_name: '',
          principle: '',
          website_url: ''
        },
        selectedLogo: '',
        selectedBackground: '',
        selectedLoginLogo: '',
        selectedLoginBackground: '',
        availableLogos: {}
      }
    },
    components: {
        ResponseInfo
    },
    methods: {
        addBusinessUnit() {
          this.$store.dispatch('addBusinessUnit', {
            unitData: this.unitData,
            selectedLogo: this.selectedLogo,
            selectedBackground: this.selectedBackground,
            selectedLoginLogo: this.selectedLoginLogo,
            selectedLoginBackground: this.selectedLoginBackground
          })
        },
        getImgUrl(type) {
          return awsUrl() + type + '/'
        },
        changeSelectedLogo(value) {
          this.selectedLogo = value
        },
        changeSelectedBackground(value) {
          this.selectedBackground = value
        },
        changeSelectedLoginLogo(value) {
          this.selectedLoginLogo = value
        },
        changeSelectedLoginBackground(value) {
          this.selectedLoginBackground = value
        },
        goBack() {
          this.$router.push('/client_configuration')
        },
        getAvailableLogos() {
          this.$store.dispatch('getAvailableBusinessUnitLogos').then(() => {
            this.availableLogos = this.getAvailableBusinessUnitLogos
          })
        }
    },
    computed: {
      ...mapGetters(['allTemplateDetails', 'getBusinessUnitInfo', 'getAvailableBusinessUnitLogos', 'getAvailableBusinessUnitBackgrounds', 'getResponseInfo'])
    },
    created() {
      if(!this.$store.getters.getAvailableBusinessUnitLogos.length > 0) {
        this.getAvailableLogos()
      } else {
        this.availableLogos = this.getAvailableBusinessUnitLogos
      }
    }
}
</script>

<style scoped>
  .padding-fix {
    padding: 0px;
  }
  .logo-preview {
    width: 250px;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 100%;
    max-height: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  .logo-preview > img {
    max-height: 100%;
    max-width: 100%;
  }
  .no-logo-img {
    height: 250px;
    width: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(236,236,236,0.8);
    box-shadow: 0px 0px 2px gray;
  }
  .no-logo-text {
    font-size: 40px;
  }
  .logos-div {
    display: flex;
    align-items: center;
  }
</style>